<template>
  <div v-if="demandeImpression">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" v-if="demandeImpression.id">
                  {{ $t('editionDemandeImpression.title.edit') }}
                </h1>
                <h1 class="title is-size-3" v-else>
                  {{ $t('editionDemandeImpression.title.add') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
            <a class="button btn-modal-annuler" @click="actionBtnReturn()">
              {{ $t('general.button.cancel') }}
            </a>
            <a class="button is-addOrEdit mgl-10px"
               @click="checkPermissions(permDemandeImpression.maj) ? addOrUpdateDemandeImpression()
                  : showPopUp()">
              {{ $t('general.button.sauvegarder') }}
            </a>
              <piece-jointe-button
                class="mgr-2"
                :perm="permDemandeImpression.maj">
              </piece-jointe-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="demandeImpression.id
                            ? 'editionDemandeImpression.error.demandeUpdate' :
                            'editionDemandeImpression.error.demandeAdd'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
    </div>

    <infos-generales :demandeImpression="demandeImpression">
    </infos-generales>
    <edition-dispositif class="mgt-20px"
      :demandeImpression="demandeImpression"
      :clientId="demandeImpression.clientId">
    </edition-dispositif>
    <edition-campagne class="mgt-20px"
      v-if="moduleCampagneActive"
      :demandeImpression="demandeImpression">
    </edition-campagne>
    <input-text-area-card
      :title="$t('editionDemandeImpression.infoGenerale.description')"
      :label="$t('editionDemandeImpression.infoGenerale.description')"
      v-model="demandeImpression.description"/>
    <edition-commentaire class="mgt-20px"
      :demandeImpression="demandeImpression">
    </edition-commentaire>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import genererDemandeImpression from '@/services/logistique/demandeImpression/genererDemandeImpression';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { create, get, update } from '@/api/logistique/demandeImpression/index';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/demandeImpression/translateDemandeImpression';
import validation from '@/services/logistique/demandeImpression/validationDemandeImpression';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CAMPAGNE, SET_DEMANDE_IMPRESSION } from '@/store/modules/logistique/demandeImpression-mutation-type';
import infosGenerales from '@/components/logistique/demandeImpression/edition/infosGenerales';
import editionDispositif from '@/components/logistique/demandeImpression/edition/editionDispositif';
import editionCampagne from '@/components/logistique/demandeImpression/edition/editionCampagne';
import editionCommentaire from '@/components/logistique/demandeImpression/edition/editionCommentaire';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import piecesJointes from '@/components/general/piecesJointes';
import inputTextAreaCard from '@/components/general/inputTextAreaCard';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const DemandeImpression = createNamespacedHelpers('demandeImpression');

export default {
  name: 'm_demandeImpression',
  data() {
    return {
      permDemandeImpression: DEMANDE_IMPRESSION,
      demandeImpression: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    infosGenerales,
    editionDispositif,
    editionCampagne,
    editionCommentaire,
    pieceJointeButton,
    piecesJointes,
    inputTextAreaCard,
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...DemandeImpression.mapGetters({
      campagneStore: 'campagne',
      demandeImpressionStore: 'demandeImpression',
    }),
    breadcrumb() {
      return [
        { title: this.$t('editionDemandeImpression.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editionDemandeImpression.breadcrumb.listeDemandeImpression'), route: { name: 'l.logistique.demande_impression' }, isActive: false },
        {
          title: this.$route.params.id ? this.$t('editionDemandeImpression.breadcrumb.edit')
            : this.$t('editionDemandeImpression.breadcrumb.nouvelleDemandeImpression'),
          route: {},
          isActive: true,
        },
      ];
    },
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...DemandeImpression.mapMutations({
      setCampagneStore: SET_CAMPAGNE,
      setDemandeImpressionStore: SET_DEMANDE_IMPRESSION,
    }),
    actionBtnReturn() {
      const { id } = this.$route.params;
      this.$router.push({
        name: id ? 'c.logistique.demande_impression' : 'l.logistique.demande_impression',
        params: { id },
      });
    },
    async addOrUpdateDemandeImpression() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let demandeImpression = cloneDeep(this.demandeImpression);
        demandeImpression.dateDemande = formatIsoDate(
          demandeImpression.dateDemande,
        );
        demandeImpression.dateLimite = formatIsoDate(demandeImpression.dateLimite);
        if (this.$route.params.id) {
          demandeImpression = (await update(demandeImpression)).data.result;
          await this.updateAttachments(demandeImpression.id);
          messageSucces(this.$t('editionDemandeImpression.success.demandeUpdate'));
        } else {
          demandeImpression = (await create(demandeImpression)).data.result;
          await this.insertAttachments(demandeImpression.id);
          messageSucces(this.$t('editionDemandeImpression.success.demandeAdd'));
        }
        loadingComponent.close();
        await this.$router.push(
          { name: 'c.logistique.demande_impression', params: { id: demandeImpression.id } },
        );
      } catch (e) {
        if (e.response?.data?.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'DemandeImpression' });
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.campagne.key]);

      let demande = null;
      if (this.demandeImpressionStore) {
        demande = cloneDeep(this.demandeImpressionStore);
        this.setDemandeImpressionStore(null);
        if (this.campagneStore) {
          demande.campagne = this.campagneStore;
          demande.campagneId = this.campagneStore.id;
          this.setCampagneStore(null);
        }
      } else if (this.$route.params.id) {
        demande = (await get(this.$route.params.id)).data.result;
      } else {
        demande = genererDemandeImpression();
        demande.societeId = this.societeActive.id;
        demande.typeOtId = this.societeActive.typeOtImpressionId;
      }
      if (demande.dateDemande) demande.dateDemande = new Date(demande.dateDemande);
      if (demande.dateLimite) demande.dateLimite = new Date(demande.dateLimite);
      if (demande.id) {
        await this.setAttachmentElementId({ id: demande.id });
        this.setInformationPage(this.$t('pageDemandeImpression.modification'));
      } else {
        this.setInformationPage(this.$t('pageDemandeImpression.creation'));
      }
      this.demandeImpression = demande;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
